import React from 'react'
import { Breakpoint } from '../Utils/media'
import {
  AppHeaderLogoLinkStyled,
  AppHeaderLogoFullStyled,
  AppHeaderLogoCompactStyled,
} from './AppHeaderLogo.styles'
import { Icon } from '../Common/Icon'
import { colors } from '../Theme/Common'
import { SvgLazy } from '../Common/Svg/SvgLazy'

type AppHeaderLogoProps = {
  /** Breakpoint width of when compact icon is used instead. */
  compactBreakpoint: keyof typeof Breakpoint
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export const AppHeaderLogo = ({ compactBreakpoint, onClick }: AppHeaderLogoProps): JSX.Element => {
  return (
    <AppHeaderLogoLinkStyled id='home-page' href='/' onClick={onClick} aria-label='TABtouch Logo'>
      <AppHeaderLogoFullStyled compactBreakpoint={compactBreakpoint}>
        <SvgLazy width='100%' color={colors.white} name='TABtouchLogo' />
      </AppHeaderLogoFullStyled>

      <AppHeaderLogoCompactStyled compactBreakpoint={compactBreakpoint}>
        <Icon type='tabtouchLogoCompact' size='3rem' />
      </AppHeaderLogoCompactStyled>
    </AppHeaderLogoLinkStyled>
  )
}
